import React from 'react'

import EditPriceListForm from '../../modules/PriceList/components/EditPriceListForm'
export default function EditPriceListPage() {
  return <EditPriceListForm />
}
